<template>
  <v-dialog
    persistent=""
    v-model="dialog"
    fullscreen=""
    @click:outside="$emit('CloseModal')"
  >
    <v-card>
      <v-toolbar
        color="primary"
        :class="
          $vuetify.breakpoint.smAndDown
            ? 'white--text font-weight-bold'
            : 'headline white--text font-weight-bold'
        "
        >USER AVATAR<v-spacer></v-spacer>
        <v-btn color="white" x-large="" icon @click="$emit('CloseModal')"
          ><v-icon>mdi-close</v-icon></v-btn
        ></v-toolbar
      >

      <v-card-text>
        <div class="d-flex justify-center my-12">
          <v-avatar v-if="user.avatar" size="300" class="mx-auto">
            <v-img :src="user.avatar"></v-img
          ></v-avatar>
        </div>

        <upload-photo class="my-12"></upload-photo>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadPhoto from "./UploadPhoto";
import { mapState } from "vuex";
export default {
  components: {
    UploadPhoto
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  props: ["dialog"]
};
</script>
<style scope></style>
